import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpResponse } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { HttpHandler } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

    private requests: HttpRequest<any>[] = [];
    constructor(private loaderService: LoaderService) { }

    /* intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.loaderService.show();
        return next
            .handle(req)
            .pipe(
                tap((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        if(event.status === 200 && event.type === 4) {
                            this.loaderService.hide();
                        }
                    }
                }, (error) => {
                    console.log(error);
                    this.loaderService.hide();
                })
            );
    } */

    removeRequest(req: HttpRequest<any>) {
        const i = this.requests.indexOf(req);
        if (i >= 0) {
          this.requests.splice(i, 1);
        }
        if (!req.headers.get('hideLoader') || this.loaderService.isLoading.value) {
          this.loaderService.isLoading.next(this.requests.length > 0);
        }
      }
      intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!req.headers.get('hideLoader')) {
          this.loaderService.isLoading.next(true);
          // req.headers.delete('hideLoader');
        } else {
          this.requests.push(req);
        }
        return Observable.create(observer => {
          const subscription = next.handle(req)
            .subscribe(
              event => {
                if (event instanceof HttpResponse) {
                  if (!req.headers.get('hideLoader') || this.requests.length) {
                    this.removeRequest(req);
                  }
                  observer.next(event);
                }
              },
              err => {
                // alert('error' + err);
                // console.log('error', err);
                if (!req.headers.get('hideLoader') || this.requests.length) {
                  this.removeRequest(req);
                }
                observer.error(err);
              },
              () => {
                if (!req.headers.get('hideLoader') || this.requests.length) {
                  this.removeRequest(req);
                }
                observer.complete();
              });
          // remove request from queue when cancelled
          return () => {
            if (!req.headers.get('hideLoader')) {
              this.removeRequest(req);
            }
            subscription.unsubscribe();
          };
        });
      }
}
